import { render, staticRenderFns } from "./accountInfoIndex.vue?vue&type=template&id=44b622ca&scoped=true"
import script from "./accountInfoIndex.vue?vue&type=script&lang=js"
export * from "./accountInfoIndex.vue?vue&type=script&lang=js"
import style0 from "./accountInfoIndex.vue?vue&type=style&index=0&id=44b622ca&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b622ca",
  null
  
)

export default component.exports